'use client';

import type { Tables } from '@root/database';
import Image from 'next/image';
import { toast } from 'sonner';
import { useState } from 'react';
import { DeleteConfirmDialog } from '@/components/ui/DeleteConfirmDialog';
import { deleteGame } from '@/lib/games/actions';
import { GameDialog } from './GameDialog';
interface GamesListProps {
  games: Tables<'game'>[];
}
export const GamesList = ({
  games
}: GamesListProps) => {
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const handleDelete = async (id: string) => {
    setDeletingId(id);
    try {
      await deleteGame(id);
      toast.success('Jeu supprimé avec succès');
    } catch (error) {
      console.error(error);
      toast.error('Impossible de supprimer ce jeu (il est peut-être utilisé par un tournoi)');
    } finally {
      setDeletingId(null);
    }
  };
  return <div className="w-full space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-white">Jeux</h2>
        <GameDialog />
      </div>

      <div className="w-full rounded-lg border border-white/20 bg-white shadow-lg overflow-hidden">
        <div className="w-full overflow-x-auto">
          <table className="w-full min-w-full">
            <thead className="border-b border-gray-200 bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">
                  Image
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">
                  Logo & Nom
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">
                  Console
                </th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-900">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {games.length === 0 ? <tr>
                  <td className="px-4 py-8 text-center text-gray-500" colSpan={4}>
                    Aucun jeu pour le moment
                  </td>
                </tr> : games.map(game => <tr key={game.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        {game.image_url && <Image alt={game.name} className="rounded object-cover" height={50} src={game.image_url} width={75} />}
                        {game.help_card && <Image alt={game.name} className="rounded object-cover" height={50} src={game.help_card} width={75} />}
                      </div>
                    </td>
                    <td className="px-4 py-3 font-medium text-gray-900">
                      <div className="flex items-center gap-2">
                        {game.logo && <Image alt={game.name} className="rounded object-cover" height={25} src={game.logo} width={25} />}
                        {game.name}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-gray-700">{game.console}</td>
                    <td className="px-4 py-3">
                      <div className="flex justify-end gap-1">
                        <GameDialog game={game} />
                        <DeleteConfirmDialog description="Cette action est irréversible. Le jeu sera définitivement supprimé." isLoading={deletingId === game.id} title="Supprimer le jeu ?" onConfirm={() => handleDelete(game.id)} />
                      </div>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};